import moment from "moment";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from "../../../../configuracion/validaciones";

export const ImprimirProducto = (producto) => {
  if (!producto) return;

  const {
    nombre,
    codigo,
    descripcion,
    precioSinImpuesto,
    precioConImpuesto,
    isvConImpuesto,
    impuesto,
    existencia,
    estado,
    productoTipo,
    lotes = []
  } = producto;

  const html = `
    <div style="font-family: 'Arial', sans-serif; width: 100%; color: #000; font-size: 13px; line-height: 1.2;">
      
      <div style="text-align: center; margin-bottom: 10px;">
        ${NegocioConfig.logo ? `<img src="${NegocioConfig.logo}" alt="Logo" style="max-width: 80px; height: auto; margin-bottom: 5px;">` : ""}
        <div style="font-weight: bold; font-size: 16px; text-transform: uppercase;">${NegocioConfig.nombre}</div>
        <div style="font-size: 11px;">${NegocioConfig.direccion}</div>
        <div style="font-size: 11px; margin-top: 2px;">RTN: ${NegocioConfig.rtn}</div>
        <div style="font-size: 11px;">Tel: ${NegocioConfig.telefono}</div>
      </div>

      <div style="text-align: center; font-weight: bold; margin: 10px 0; font-size: 14px; border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 5px 0;">
        FICHA TÉCNICA DE PRODUCTO
      </div>

      <div style="margin-bottom: 10px;">
        <div style="font-weight: bold; font-size: 14px; text-align: center; margin-bottom: 5px;">${nombre}</div>
        <div><strong>Código:</strong> ${codigo}</div>
        <div><strong>Categoría:</strong> ${productoTipo?.nombre || 'N/A'}</div>
        <div><strong>Estado:</strong> ${estado}</div>
        <div><strong>Stock Total:</strong> ${existencia}</div>
        <div style="margin-top: 5px; font-size: 11px; font-style: italic;">${descripcion}</div>
      </div>

      <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
        <thead>
          <tr style="border-bottom: 2px solid #000;">
            <th style="text-align: left; padding: 4px 0;">Descripción</th>
            <th style="text-align: right; padding: 4px 0;">Monto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 4px 0;">Precio base (sin ISV)</td>
            <td style="text-align: right; padding: 4px 0;">${formatoMoneda(precioSinImpuesto)}</td>
          </tr>
          <tr>
            <td style="padding: 4px 0;">ISV (${impuesto})</td>
            <td style="text-align: right; padding: 4px 0;">${formatoMoneda(isvConImpuesto)}</td>
          </tr>
          <tr style="font-weight: bold; font-size: 15px; border-top: 1px solid #000;">
            <td style="padding: 6px 0;">PRECIO FINAL</td>
            <td style="text-align: right; padding: 6px 0;">${formatoMoneda(precioConImpuesto)}</td>
          </tr>
        </tbody>
      </table>

      ${lotes.map((lote, index) => `
        <div style="margin-top: 15px; background-color: #f2f2f2; padding: 4px; font-weight: bold; font-size: 12px; border: 1px solid #000;">
          LOTE: ${lote.nombre_lote} (${moment(lote.fecha_ingreso).format('DD/MM/YYYY')})
        </div>
        
        <table style="width: 100%; border-collapse: collapse; font-size: 11px; margin-top: 5px;">
          <tr style="border-bottom: 1px solid #ccc;">
            <th style="text-align: left;">Cant. Escala</th>
            <th style="text-align: right;">Precio Unit.</th>
          </tr>
          ${lote.loteprecios?.map(p => `
            <tr>
              <td style="padding: 2px 0;">A partir de ${p.cantidad} unidades</td>
              <td style="text-align: right; padding: 2px 0;">${formatoMoneda(p.precio)}</td>
            </tr>
          `).join('')}
        </table>

        <div style="margin-top: 5px; font-size: 11px;">
          <strong>Distribución:</strong>
          ${lote.loteinventarios?.map(inv => `
            <div style="display: flex; justify-content: space-between; padding: 1px 0; border-bottom: 0.5px dashed #ccc;">
              <span>• ${inv.inventarioTipo?.nombre}:</span>
              <span>${inv.existencia} unidades</span>
            </div>
          `).join('')}
        </div>
      `).join('')}

      <div style="text-align: center; margin-top: 20px; font-size: 11px; border-top: 1px solid #000; padding-top: 10px;">
        <div>Fecha impresión: ${moment().format('DD/MM/YYYY HH:mm:ss')}</div>
        <div style="font-weight: bold; margin-top: 5px;">*** FIN DEL REPORTE ***</div>
      </div>
    </div>
    `;

  ImprimirEnIframe(html, `Ficha_${codigo}`);
};